<a [link]="route" class="item-menu" loader-button (click)="click(name)">
  <small *ngIf="notification > 0">{{ notification }}</small>
  <span>
    <svg-icon [applyCss]="true" class="icon-menu" src="{{this.path_assets + icon}}"></svg-icon> {{ name }}
  </span>
</a>
